import { supabase } from '@/services/supabase/client';

import { deriveInstitutionRoles } from './institution-roles.derive';

import type { InstitutionRoles } from './institution-roles.derive';

/**
 * "Que tipo de conta sou eu, para a navegação?" — vínculos ativos da pessoa
 * reduzidos ao que a barra e o menu decidem (`config/navigation.ts`).
 *
 * Mora em `services/` porque a barra e o menu (`components/layouts`) não podem
 * importar de `modules/`. A consulta é leve (só tipo da casa e papel) e é
 * apenas **apresentação**: quem autoriza é a RLS.
 */
export const institutionRolesService = {
  async mine(profileId: string): Promise<InstitutionRoles> {
    const { data, error } = await supabase
      .from('institution_members')
      .select('institution_id, role, institution:institutions!inner(institution_type)')
      .eq('profile_id', profileId)
      .eq('status', 'active')
      // Casa encerrada ou suspensa não é destino: o perfil dela não abre mais.
      .is('institution.archived_at', null)
      .is('institution.suspended_at', null)
      .order('created_at', { ascending: true });

    if (error) throw error;

    return deriveInstitutionRoles(
      (data ?? []).map((row) => ({
        institutionId: row.institution_id,
        role: row.role,
        institutionType: row.institution.institution_type,
      })),
    );
  },
};
